import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ColorFilter from '../../../Component/ColorFilter';
import { AwaitIterators } from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';

export class NodePress extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        let colorFilter: ColorFilter = gameObject.getComponent(ColorFilter);
        if (colorFilter) {
            colorFilter.brightness = 1;
        } else {
            colorFilter = gameObject.addComponent<ColorFilter>(ColorFilter, {
                brightness: 1,
            });
        }

        const colorTween: Tween = this.getTween(colorFilter);
        colorTween.to({ brightness: 1.2 }, 100);

        const scaleTween: Tween = this.getTween(transform.scale);
        scaleTween.to({ x: 0.95, y: 0.95 }, 100);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(colorTween),
        ]);
    }
}
